type Env = {
  API_BASE_URL: string;
  API_FLAVOUR: string;
};

export const ENV: Env = (window as any)?._env_;